<script setup lang="ts">

import { usePresentation } from '../Types';

type Props = { animate?: boolean, animation?: string, triggerIndex?: number }
const { animate = false, triggerIndex = 0 } = defineProps<Props>();

const presentation = usePresentation();

</script>

<template>
    <Triggered v-if="animate || animation != null"
               :trigger-index="triggerIndex" 
               :duration="300" 
               :animation="animation || 'zoom'" 
               v-slot="{ isTriggered, isVisible }">
        <div class="flex justify-center text-center text-xl 2xl:text-2xl 3xl:text-3xl 2xl:mt-6 font-bold uppercase 
                    pt-6 pb-2 2xl:px-12 transition-colors duration-1000 tracking-wider"
             :style="{ color: isVisible ? presentation.theme.keyMessageColor : 'currentColor'}"
             :class="isVisible? 'text-emerald-500' : 'text-white/30'">
            <slot/>
        </div>
    </Triggered>
    <div v-else 
         class="flex justify-center text-center text-xl 2xl:text-2xl 3xl:text-3xl 2xl:mt-2 font-bold uppercase 
                pt-8 px-12 text-emerald-500 tracking-wider">
        <slot/>
    </div>

</template>